import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { config } from './config';
import './styles/global.css';

async function enableMocks() {
  // The DEV guard is static, so production bundles drop the mock layer entirely.
  if (import.meta.env.DEV) {
    if (config.mock === 'off') return;
    const { startMockWorker } = await import('./mocks/browser');
    await startMockWorker();
  }
}

enableMocks()
  .catch((e) => console.error('mock layer failed to start', e))
  .then(async () => {
    const { App } = await import('./App');
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  });
